import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const DEFAULT_COLOR_PALETTE = 'foxen_duo';

export const FOXEN_PALETTES = [
  {
    key: 'foxen_duo',
    label: '🦊 FoxeN Duo (Padrão)',
    swatchClass: 'foxen-swatch-foxen_duo',
  },
  {
    key: 'foxen_fire',
    label: '🔥 FoxeN Fire (Laranja)',
    swatchClass: 'foxen-swatch-foxen_fire',
  },
  {
    key: 'foxen_royal',
    label: '💜 Royal Violeta',
    swatchClass: 'foxen-swatch-foxen_royal',
  },
  {
    key: 'emerald',
    label: '💎 Esmeralda Pro',
    swatchClass: 'foxen-swatch-emerald',
  },
  {
    key: 'cyber_ocean',
    label: '🌊 Cyber Ocean',
    swatchClass: 'foxen-swatch-cyber_ocean',
  },
  {
    key: 'classic_blue',
    label: '🔵 Clássico (Original)',
    swatchClass: 'foxen-swatch-classic_blue',
  },
];

export const applyColorPalette = paletteKey => {
  const palette =
    paletteKey ||
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_PALETTE) ||
    DEFAULT_COLOR_PALETTE;

  if (palette === 'classic_blue') {
    document.documentElement.removeAttribute('data-foxen-palette');
  } else {
    document.documentElement.setAttribute('data-foxen-palette', palette);
  }
};

export const setColorPalette = paletteKey => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_PALETTE, paletteKey);
  applyColorPalette(paletteKey);
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }

  applyColorPalette();
};
